// eslint-disable import/extensions
import './global.scss';

// eslint-disable-next-line import/no-extraneous-dependencies
import { App } from '@roku-web-core/app';
import { AmoebaPlugin } from '@roku-web-core/ks-amoeba';
import { AjaxPluginsInstallerPlugin } from '@roku-web-core/app-plugin-ajax-plugins';
import { AnalyticsPlugin, Analytics } from '@roku-web-core/app-plugin-analytics';
import { CASLPlugin } from '@roku-web-core/app-plugin-casl';
import { GDPRCookieConsentPlugin } from '@roku-web-core/app-plugin-gdpr-cookie-consent';
import { EventsPlugin } from '@roku-web-core/app-plugin-global-events';
import { MessageOverridesPlugin } from '@roku-web-core/app-plugin-message-overrides';
import { Meta, MetaPlugin } from '@roku-web-core/app-plugin-meta';
import { MobileAppConnector, MobileAppConnectorPlugin } from '@roku-web-core/app-plugin-mobile-app-connector';
import { NavExternalFooterPlugin } from '@roku-web-core/app-plugin-nav-external-footer';
import { NavUniversalHeaderPlugin } from '@roku-web-core/app-plugin-nav-universal-header';
import { PageRendererReactPlugin } from '@roku-web-core/app-plugin-page-renderer-react';
import { TimeOnSite, TimeOnSitePlugin } from '@roku-web-core/app-plugin-timeonsite';
import { UserContext, UserContextPlugin } from '@roku-web-core/app-plugin-uc';
import headerConfig from './headerConfig';

const gdprCookieConsentPlugin = new GDPRCookieConsentPlugin({
  App,
});
const caslPlugin = new CASLPlugin({
  App,
});
const messageOverridesPlugin = new MessageOverridesPlugin({
  App,
});
const mobileAppConnectorModel = new MobileAppConnector({
  App,
});
const mobileAppConnectorPlugin = new MobileAppConnectorPlugin({
  App,
  MobileAppConnector: mobileAppConnectorModel,
});
const metaModel = new Meta({
  App,
});
const metaPlugin = new MetaPlugin({
  App,
  Meta: metaModel,
});
const userContextModel = new UserContext({
  App,
});
const analyticsModel = new Analytics({
  App,
  UserContext: userContextModel,
});
const timeOnSiteModel = new TimeOnSite({
  App,
  Analytics: analyticsModel,
});
const timeOnSitePlugin = new TimeOnSitePlugin({
  App,
  Analytics: analyticsModel,
  TimeOnSite: timeOnSiteModel,
});
const analyticsPlugin = new AnalyticsPlugin({
  App,
  Analytics: analyticsModel,
  UserContext: userContextModel,
  TimeOnSite: timeOnSiteModel,
});
const userContextPlugin = new UserContextPlugin({
  App,
  Analytics: analyticsModel,
});
const amoebaPlugin = new AmoebaPlugin({
  Analytics: analyticsModel,
  // eslint-disable-next-line no-undef
  ResourceManager: Resource,
});
const ajaxPluginsInstallerPlugin = new AjaxPluginsInstallerPlugin({
  App,
  Analytics: analyticsModel,
  TimeOnSite: timeOnSiteModel,
});

const globalEventsPlugin = new EventsPlugin({
  App,
  Analytics: analyticsModel,
});

const pageRendererReactPlugin = new PageRendererReactPlugin({
  App,
});
const universalHeaderPlugin = new NavUniversalHeaderPlugin({
  App,
  headerConfig: {
    ...headerConfig,
    useNewBreakpoints: true,
  },
  onUMAEnabled: () => {
    pageRendererReactPlugin.setIsUMAVisible(true);
  },
});
const externalFooterPlugin = new NavExternalFooterPlugin({
  App,
  footerConfig: {
    useNewBreakpoints: true,
    isCompact: true,
  },
});

const plugins = [
  gdprCookieConsentPlugin,
  amoebaPlugin,
  ajaxPluginsInstallerPlugin,
  analyticsPlugin,
  caslPlugin,
  globalEventsPlugin,
  messageOverridesPlugin,
  metaPlugin,
  mobileAppConnectorPlugin,
  pageRendererReactPlugin,
  universalHeaderPlugin,
  externalFooterPlugin,
  timeOnSitePlugin,
  userContextPlugin,
];

App.initializeDefaultOnLoad({
  // eslint-disable-next-line no-undef
  ResourceManager: Resource,
  plugins,
});
